<template>
  <div>
    <v-card style="padding: 20px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card-title>Change password</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="oldPassword"
            label="Old password"
            autofocus
            type="password"
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
            v-model="newPassword"
            label="New password"
            type="password"
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
            v-model="confirmPassword"
            label="Confirm new password"
            type="password"
            :rules="[rules.required, rules.sameAsNewPassword]"
          ></v-text-field>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
          <div class="row row--end">
            <v-btn
              text
              @click="$emit('cancel')"
            >Cancel
            </v-btn>
            <v-btn
              :disabled="!valid"
              text
              color="primary"
              @click="changePassword"
            >Change
            </v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import {ConnectionService} from "../../services/connection.service";

export default {
  name: "ChangePasswordForm",
  data: function () {
    return {
      valid:           true,
      oldPassword:     "",
      newPassword:     "",
      confirmPassword: "",
      rules:           {
        required:          value => !!value || 'Required',
        sameAsNewPassword: value => value == this.newPassword || 'Passwords do not match'
      }
    }
  },
  methods: {
    async changePassword() {
      let valid = this.$refs.form.validate();

      if (!valid) return;

      const connection = ConnectionService.getConnection("/settings");

      await connection.start();

      const response = await connection.invoke("ChangePassword", this.oldPassword, this.newPassword);

      if (response.resultKind !== "Success") {
        alert(response.reason);
      } else {
        this.$emit('ok');
      }

      await connection.stop();
    },
  }
}
</script>

<style scoped>
</style>
